import { render } from "./SourceCode.vue?vue&type=template&id=1b351dff&scoped=true"
import script from "./SourceCode.vue?vue&type=script&lang=js"
export * from "./SourceCode.vue?vue&type=script&lang=js"

import "./SourceCode.vue?vue&type=style&index=0&id=1b351dff&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1b351dff"

export default script